import React from 'react';

import Button from '~/components/core/Atomic/Buttons/Button';
import { FeedbackSnackbar, useSnackbar } from '~/components/core/Molecules/Snackbar';
import { CopyToClipboardIcon } from '~/components/icons';

interface CliveCopyToClipboardButtonProps {
  textToCopy: string;
  className?: string;
  onCopy?: () => void;
  ariaLabel?: string;
}

export const CliveCopyToClipboardButton: React.FC<CliveCopyToClipboardButtonProps> = ({
  textToCopy,
  className,
  onCopy,
  ariaLabel = 'Copy to clipboard',
}) => {
  const { snackbarState, showSnackbar, closeSnackbar } = useSnackbar();

  const handleCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      showSnackbar('Copied to clipboard', 'success');
      onCopy?.();
    } catch (error) {
      showSnackbar('Failed to copy to clipboard', 'error');
    }
  };

  return (
    <>
      <Button
        onClick={handleCopyToClipboard}
        className={className}
        variant="text"
        disableRipple
        aria-label={ariaLabel}
        style={{
          border: 'none',
          backgroundColor: 'white',
          padding: '8px',
          minWidth: 'auto',
        }}
      >
        <CopyToClipboardIcon />
      </Button>
      <FeedbackSnackbar state={snackbarState} onClose={closeSnackbar} />
    </>
  );
};

export default CliveCopyToClipboardButton;
